import {
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    useDisclosure,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';

import { type OptimizationMeta } from '@/cip/_openapi/portfolio-optimizer';

import { AlgoDetailsView } from '../TradeDetails/AlgoDetailsView';

interface AdvancedViewDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    optimizationId: number;
    portfolioGuid: string;
    pId: string;
    optimizationMeta?: OptimizationMeta;
}

export const AdvancedViewDrawer = ({
    isOpen,
    onClose,
    optimizationId,
    portfolioGuid,
    pId,
    optimizationMeta,
}: AdvancedViewDrawerProps) => {
    return (
        <Drawer isOpen={isOpen} onClose={onClose} size="huge" placement="right">
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>Advanced View - {portfolioGuid}</DrawerHeader>
                <DrawerBody>
                    <AlgoDetailsView optimizationId={optimizationId} pId={pId} optimizationMeta={optimizationMeta} />
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    );
};

export const useAdvancedViewDrawerControls = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [portfolioGuid, setPortfolioGuid] = useState<string>('');
    const [pId, setPId] = useState<string>('');

    const viewAdvanced = useCallback(
        (guid: string, portfolioId: string) => {
            setPortfolioGuid(guid);
            setPId(portfolioId);
            onOpen();
        },
        [onOpen],
    );

    return {
        isOpen,
        onClose,
        portfolioGuid,
        pId,
        viewAdvanced,
    };
};
